<template>
  <div>
    <slot />

    <!-- Global Toast Notification -->
    <Toast
      :visible="toast.visible"
      :title="toast.title"
      :message="toast.message"
      :variant="toast.variant"
      @close="hideToast"
    />

    <!-- Global Modals -->
    <DeliverySettingsModal
      :is-open="isScheduleModalOpen"
      :show-address="scheduleModalOptions.showAddress"
      :show-schedule="scheduleModalOptions.showSchedule"
    />
    <LocationModal />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DeliverySettingsModal from "@/components/DeliverySettings/DeliverySettingsModal.vue";
import LocationModal from "@/components/Location/LocationModal.vue";
import { Toast } from "@/components/ui";

export default {
  name: "MainLayout",
  components: {
    DeliverySettingsModal,
    LocationModal,
    Toast
  },
  computed: {
    ...mapGetters(["isScheduleModalOpen", "scheduleModalOptions"]),
    toast() {
      const toastState = this.$store.getters["app/getToast"];
      return (
        toastState || {
          visible: false,
          title: "",
          message: "",
          variant: "info"
        }
      );
    }
  },
  methods: {
    ...mapActions("app", ["hideToast"])
  }
};
</script>
